import { FC } from "react";
import { UserDetailDTO } from "utils/helpers/models/shared/user-detail.dto";
import CustomMessageDisplay from "components/data-not-found/CustomMessageDisplay";
import noFoundGif from "assets/images/gifs/noFoundGif.gif";

interface Props {
  user: UserDetailDTO
}
const Overview: FC<Props> = ({ user }) => {
  const hostData = user?.profiles?.host;
  
  if (!hostData) {
    return (
      <div className="w-full md:w-[60%] my-5">
        <CustomMessageDisplay
          show={true}
          title="No Host Information Available"
          slogan="Host information is not available at the moment. Please try again later."
          image={noFoundGif}
          imageAlt="No host information found"
          className="py-12"
          imageClassName="w-24 h-24"
          titleClassName="text-2xl font-bold text-blackie"
          sloganClassName="text-gray-500 text-base"
        />
      </div>
    );
  }

  return (
    <div className="w-full md:w-[60%] my-5">
      <h1 className="text-3xl font-medium text-blackie">{hostData.businessName || "-"}</h1>
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 my-6">
        <div>
          <h3 className="text-blackie text-xl font-medium mb-2">
            Business Website
          </h3>
          <p className="text-lightBlackText text-base">{hostData.businessWebsite || "-"}</p>
        </div>
        <div>
          <h3 className="text-blackie text-xl font-medium mb-2">
            Phone Number
          </h3>
          <p className="text-lightBlackText text-base">{hostData.businessPhoneNumber || "-"}</p>
        </div>
        <div>
          <h3 className="text-blackie text-xl font-medium mb-2">Email</h3>
          <p className="text-lightBlackText text-base">{hostData.businessEmail || "-"}</p>
        </div>
      </div>
      <div>
        <div>
          <h3 className="text-blackie text-xl font-medium mb-2">Mission</h3>
          <p className="text-lightBlackText text-base">
            {hostData.missionStatement || "-"}
          </p>
        </div>
        <div>
          <h3 className="text-blackie text-xl font-medium mb-2 mt-3">About </h3>
          <p className="text-lightBlackText text-base">
            {hostData.about || "-"}
          </p>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 my-6">
          <div className="">
            <h3 className="text-blackie text-xl font-medium mb-2">Industry</h3>
            <p className="text-lightBlackText text-base">
              {hostData.industry.replace(/_/g, " ") || "-"}
            </p>
          </div>
          <div className="">
            <h3 className="text-blackie text-xl font-medium mb-2">Address</h3>
            <p className="text-lightBlackText text-base">
              {hostData.businessAddress || "-"}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Overview;
